module.exports = __webpack_public_path__ + "static/fast-track-preparation-445c6f84e3ac23ec772294989e6c6ec3.jpg";